import { selectors } from './data'

// Feed
export function getFetching(state) {
    return selectors.feed.getFetching(state.newsReducer)
}

export function getOutdated(state) {
    return selectors.feed.getOutdated(state.newsReducer)
}

export function getNews(state) {
    return selectors.feed.getNews(state.newsReducer)
}

export function getLanguage(state) {
    return selectors.feed.getLanguage(state.newsReducer)
}

export function getLocalizedNews(state) {
    return selectors.feed.getLocalizedNews(state.newsReducer)
}

export function getLocalizedNewsForLocale(state, locale) {
    return selectors.feed.getLocalizedNewsForLocale(state.newsReducer, locale)
}



// WEBPACK FOOTER //
// ./src/features/News/selectors.js